export default __webpack_public_path__ + "static/assets/med_pill_round_in_L2_solid_l_01_f.5d5d2279.png";